import { gameLiveConnection, lobbyLiveConnection } from '../services';
import { RoutePaths } from '../enums/routes';
import { gameConfigStore, popupStore } from '@pascal/pascal-core/shared/core/store';

class LiveConnection {
  handleSocketInit(pathname) {
    const { isSkipLobby } = gameConfigStore;
    return new Promise((resolve, reject) => {
      if (pathname === RoutePaths.game || pathname === RoutePaths.betShop || isSkipLobby) {
        try {
          lobbyLiveConnection?.stop().then(() => {
            gameLiveConnection
              .init()
              .then(() => {
                this.connectionInitCallback({ socketPath: pathname });
              })
              .catch(() => {
                popupStore.onConnectionError(true);
              });
          });
        } catch (err) {
          reject(err);
        }
      } else if (pathname === RoutePaths.lobby) {
        try {
          gameLiveConnection?.stop().then(() => {
            lobbyLiveConnection.init().then(() => {
              this.connectionInitCallback({ socketPath: pathname });
            });
          });
        } catch (err) {
          reject(err);
        }
      }
    });
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          res({ socketPath: window.location.pathname });
        });
      });
    });
  }

  executeThreeJsAnimation(withoutInitial) {
    if (!withoutInitial) {
      gameLiveConnection.sendGameGetInitialState();
    }

    // loadThree.execute()
    //   .then(() => {
    //     gameLiveConnection.sendGameGetInitialState().then(() => {
    //       // loadingStore.setThreeJsIsLoad(true);
    //     });
    //   });
    // return;
    //////////////////////////

    // const canvas = document.querySelector('#game-canvas');
    // if (!canvas) return;
    // loadThree.setupRoot(canvas);
    // loadThree.execute()
    //   .then(() => {
    //     gameLiveConnection.sendGameGetInitialState().then(() => {
    //       // loadingStore.setThreeJsIsLoad(true);
    //     });
    //   });
  }

  connectionInitCallback({ socketPath }) {
    const initialInvokes = {
      [RoutePaths.lobby]: () => lobbyLiveConnection.sendLobbyGetInitialState(),
      [RoutePaths.game]: () => {
        this.executeThreeJsAnimation();
      },
      [RoutePaths.betShop]: () => {
        this.executeThreeJsAnimation();
      },
    };
    if (initialInvokes[socketPath]) {
      initialInvokes[socketPath]();
    }
  }
}

export const liveConnection = new LiveConnection();
